import { NavLink } from 'react-router-dom'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Icon } from '@/ui'
import { mtc } from '@/styles'
import { navListItemStyles } from './stylesRestructured'

export interface RailNavListRestructuredProps {
  categories?: Record<
    string,
    {
      end?: boolean
      icon?: IconProp
      label: string
      to?: string
      disabled?: boolean
      isSpacer?: boolean
      pages?: unknown[] | null
    }
  > | null
  disabled?: boolean
  onCategoryClick?: (key: string) => void
}

type RailCategory = {
  end?: boolean
  icon?: IconProp
  label: string
  to?: string
  disabled?: boolean
  isSpacer?: boolean
  pages?: unknown[] | null
}

const RailItem = ({
  categoryKey,
  category,
  onCategoryClick,
}: {
  categoryKey: string
  category: RailCategory
  onCategoryClick?: (key: string) => void
}) => {
  if (category.isSpacer) {
    return (
      <li className="-mx-4 py-4" aria-hidden="true">
        <div className="border-t border-neutral-50" />
      </li>
    )
  }

  return (
    <li key={categoryKey} className={mtc(navListItemStyles())}>
      <NavLink
        end={category.end}
        to={category.to ?? location.pathname}
        onClick={() => onCategoryClick?.(categoryKey)}
      >
        {category.icon && (
          <Icon
            icon={category.icon}
            color="text-neutral-700"
            className="w-5 h-5 shrink-0"
            backgroundClassName="w-5 h-5 shrink-0"
          />
        )}
      </NavLink>
    </li>
  )
}

export const RailNavListRestructured = ({
  categories,
  onCategoryClick,
}: RailNavListRestructuredProps) => {
  if (!categories) {
    return null
  }

  const allEntries = Object.entries(categories)
  const splitPoint = allEntries.findIndex(
    ([, cat]) => cat.pages !== null && cat.pages !== undefined
  )
  const topEntries = splitPoint > 0 ? allEntries.slice(0, splitPoint) : []
  const mainEntries = splitPoint > 0 ? allEntries.slice(splitPoint) : allEntries

  return (
    <div className="flex flex-col">
      {topEntries.length > 0 && (
        <>
          <ul className="flex flex-col gap-0.5 list-none p-0 m-0">
            {topEntries.map(([key, category]) => (
              <RailItem
                key={key}
                categoryKey={key}
                category={category}
                onCategoryClick={onCategoryClick}
              />
            ))}
          </ul>
          <div className="-mx-4 py-4" aria-hidden="true">
            <div className="border-t border-neutral-50" />
          </div>
        </>
      )}
      <ul className="flex flex-col gap-0.5 list-none p-0 m-0">
        {mainEntries.map(([key, category]) => (
          <RailItem
            key={key}
            categoryKey={key}
            category={category}
            onCategoryClick={onCategoryClick}
          />
        ))}
      </ul>
    </div>
  )
}
